import {useState} from "react";
import Tooltip from '@mui/material/Tooltip';
import { Info } from "lucide-react";
import { IconButton } from "@mui/material";
import CustomDialog from "../../../../../components/Dialog/DiaCompMedium";
import { TextBmi } from "./TextBmi";
import { useTranslation } from "../../../../../language";


export default function DiaBodyInfo() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

     <Tooltip title="Info" placement="right">
        <IconButton onClick={handleOpen} size="small">
            <Info size={18} />
        </IconButton>   
    </Tooltip>


<CustomDialog open={open} onClose={handleClose}

    title={t("vitals_info_title")}
    content = {<TextBmi />}
/>

</>
)}